<template>
  <div class="full-login font-poppins">
    <div class="w-full">
      <Navbar />
      <div class="m-auto w-full">
        <div class="block sm:flex justify-center align-items-center w-full">
          <!-- BEGIN: Login Form -->
          <div class="grid grid-cols-2 gap-4 w-full">
            <div class="sm:col-span-2 md:col-span-1 col-span-2">
              <div class="my-4 mx-4 px-4 py-8">
                <div class="intro-x mt-8 px-8">
                  <h1
                    class="font-crimson_pro text-theme-9 text-3xl font-semibold"
                  >
                    Contacto
                  </h1>
                  <p class="my-3">
                    Te compartimos este directorio en caso de que quieras
                    comunicarte con alguien del equipo de CPA.
                  </p>
                </div>
                <div class="my-10 mb-4 mx-4 px-4 rounded-md sm:w-11/12 w-full">
                  <div
                    class="py-2 px-4 bg-theme-11 rounded-lg grid grid-cols-6 gap-4"
                  >
                    <div class="m-auto">
                      <img
                        class="w-32 h-32 rounded-full"
                        :src="require(`@/assets/images/profile/a1.svg`)"
                        alt="user"
                      />
                    </div>
                    <div class="col-span-5">
                      <ul role="list" class="divide-y divide-gray-200">
                        <li class="py-3 sm:py-4">
                          <div class="flex items-center space-x-4">
                            <div class="flex-1 min-w-0">
                              <h3
                                class="text-xl font-bold leading-none text-gray-900"
                              >
                                Carmen Cruz Calderón
                              </h3>
                              <h6 class="text-sm font-poppins my-1">
                                Directora de operaciones
                              </h6>
                              <h5
                                class="text-sm font-medium text-theme-9 truncate"
                              >
                                +52 5555 5555
                              </h5>
                              <p
                                class="text-sm font-medium text-theme-9 truncate"
                              >
                                carmen.cc@miempresa.com
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="my-10 mb-4 mx-4 px-4 rounded-md sm:w-11/12 w-full">
                  <div
                    class="py-2 px-4 bg-theme-11 rounded-lg grid grid-cols-6 gap-4"
                  >
                    <div class="m-auto">
                      <img
                        class="w-32 h-32 rounded-full"
                        :src="require(`@/assets/images/profile/a2.svg`)"
                        alt="user"
                      />
                    </div>
                    <div class="col-span-5">
                      <ul role="list" class="divide-y divide-gray-200">
                        <li class="py-3 sm:py-4">
                          <div class="flex items-center space-x-4">
                            <div class="flex-1 min-w-0">
                              <h3
                                class="text-xl font-bold leading-none text-gray-900"
                              >
                                Orlando Quintero Ruiz
                              </h3>
                              <h6 class="text-sm font-poppins my-1">
                                Director de logística
                              </h6>
                              <h5
                                class="text-sm font-medium text-theme-9 truncate"
                              >
                                +52 5555 5555
                              </h5>
                              <p
                                class="text-sm font-medium text-theme-9 truncate"
                              >
                                carmen.cc@miempresa.com
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sm:col-span-1 col-span-2 sm:flex hidden">
              <img
                alt="key"
                class="m-auto"
                :src="require(`@/assets/images/COT-bg/contact.png`)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <Footer />
  </div>
</template>

<style scoped>
.full-login {
  display: flex;
  min-height: 75vh;
  justify-content: center;
  background: #f0ecec;
}
</style>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'

export default {
  components: {
    Navbar,
    Footer
  }
}
</script>
